module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-office-doctor"
  }, [_c('TitleTrigger', {
    staticClass: "tab-office-doctor__trigger",
    attrs: {
      "props": 1
    }
  }), _c('div', {
    staticClass: "tab-office-doctor__container"
  }, [_c('div', {
    staticClass: "tab-office-doctor__title",
    class: {
      active: _vm.titleActive
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "tab-office-doctor__row"
  }, [_c('div', {
    staticClass: "tab-office-doctor__col-left"
  }, [_c('div', {
    staticClass: "tab-office-doctor__image",
    style: ("backgroundImage: url(" + _vm.props.image + ");")
  }, [_c('div', {
    staticClass: "tab-office-doctor__image tab-office-doctor__image--funny",
    style: ("backgroundImage: url(" + _vm.props.image_funny + ");")
  })])]), _c('div', {
    staticClass: "tab-office-doctor__col-right"
  }, [_c('div', {
    staticClass: "tab-office-doctor__container-tab"
  }, [_c('div', {
    staticClass: "tab-office-doctor__tab",
    class: {
      "tab-office-doctor__tab--active": _vm.activeTab === "education"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = "education"
      }
    }
  }, [_vm._v("Education")]), _c('div', {
    staticClass: "tab-office-doctor__tab",
    class: {
      "tab-office-doctor__tab--active": _vm.activeTab === "association"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = "association"
      }
    }
  }, [_vm._v("Associations")])]), _c('div', {
    staticClass: "tab-office-doctor__content-box",
    class: {
      'tab-office-doctor__content-box--association': _vm.activeTab === 'association'
    }
  }, [_c('transition', {
    attrs: {
      "name": "tab-office-doctor__transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === "education"),
      expression: "activeTab === \"education\""
    }],
    staticClass: "tab-office-doctor__content"
  }, [_c('div', {
    staticClass: "tab-office-doctor__tagline-education",
    domProps: {
      "innerHTML": _vm._s(_vm.props.education.tagline)
    }
  }), _c('div', {
    staticClass: "tab-office-doctor__content-education",
    domProps: {
      "innerHTML": _vm._s(_vm.props.education.content)
    }
  })])]), _c('transition', {
    attrs: {
      "name": "tab-office-doctor__transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === "association"),
      expression: "activeTab === \"association\""
    }],
    staticClass: "tab-office-doctor__content"
  }, _vm._l((_vm.props.associations), function(association, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-office-doctor__association",
      domProps: {
        "innerHTML": _vm._s(association.association)
      }
    })
  }))])], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d171296","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/tab/tab-office-doctor/tab-office-doctor.pug
// module id = 638
// module chunks = 1